<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Historial de costos</h1>
                <div class="caption">
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <empresa-select v-model="d.empresa"></empresa-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-menu
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menuDesde"
                                        :return-value.sync="menuDesde"
                                        ref="menuDesde"
                                >
                                    <v-text-field
                                            name="desde"
                                            slot="activator"
                                            label="Desde"
                                            v-model="d.desde"
                                            prepend-icon="event"
                                            readonly></v-text-field>
                                    <v-date-picker
                                            v-model="d.desde"
                                            first-day-of-week="1"
                                            locale="es-sp"
                                            scrollable
                                            @input="$refs.menuDesde.save(d.desde)"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menuHasta"
                                        transition="v-scale-transition"
                                >
                                    <v-text-field
                                            name="desde"
                                            slot="activator"
                                            label="Hasta"
                                            v-model="d.hasta"
                                            prepend-icon="event"
                                            readonly
                                            ref="menuHasta"
                                    ></v-text-field>
                                    <v-date-picker
                                            v-model="d.hasta"
                                            first-day-of-week="1"
                                            locale="es-sp"
                                            scrollable
                                            @input="$refs.menuHasta.save(d.hasta)"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <micro-item-select v-model="d.producto" :empresa="d.empresa"></micro-item-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-radio-group v-model="d.tipo" row>
                                    <v-radio label="Costos" value="costo"></v-radio>
                                    <v-radio label="% de variación" value="variacion"></v-radio>
                                </v-radio-group>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                        <v-btn dark color="pink" @click.native="variacionCalc()" :loading="loading">VARIACION</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-dialog v-model="seriesShow">
            <v-card raised>
                <v-card-text>
                    <v-data-table :headers="headers" :items="items">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.item.D3_DOC }}</td>
                            <td class="text-xs-center">{{ props.item.D3_TM }}</td>
                            <td class="text-xs-center">{{ props.item.D3_CF }}</td>
                            <td class="text-xs-right">{{ props.item.D3_QUANT | decimales}}</td>
                            <td class="text-xs-right">{{ props.item.PROMEDIO1 | decimales }}</td>
                            <td class="text-xs-right">{{ props.item.PROMEDIO2 | decimales }}</td>
                            <td class="text-xs-right">{{ props.item.PROMEDIO3 | decimales }}</td>
                            <td class="text-xs-right">{{ props.item.PROMEDIO4 | decimales }}</td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts :constructor-type="'stockChart'" style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import microItemSelect from '../../components/MicroItemSelect';
    import decimales from '../../filters/decimales';
    import moment from 'moment'
    import {mapActions} from 'vuex';
    import Highcharts from 'highcharts'
    import stockInit from 'highcharts/modules/stock'

    stockInit(Highcharts);
    export default {
        components: {empresaSelect, microItemSelect},
        filters: {decimales},
        data() {
            return {
                seriesTit: '',
                seriesShow: false,
                x: 0,
                y: 0,
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                d: {
                    empresa: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    producto: '',
                    tipo: 'variacion'
                },
                headers: [
                    {text: 'Doc', value: 'D3_DOC'},
                    {text: 'TM', value: 'D3_TM'},
                    {text: 'CF', value: 'D3_CF'},
                    {text: 'Cant', value: 'D3_QUANT'},
                    {text: 'Prom 1', value: 'PROMEDIO1'},
                    {text: 'Prom 2', value: 'PROMEDIO2'},
                    {text: 'Prom 3', value: 'PROMEDIO3'},
                    {text: 'Prom 4', value: 'PROMEDIO4'},
                ],
                items: [],
                costo: {},
                variacion: {},
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'areaspline',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'HISTORIAL DE COSTOS'
                    },
                    subtitle: {
                        text: ''
                    },
                    legend: {
                        enabled: true
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    },
                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            second: '%d-%m-%Y<br/>%H:%M:%S',
                            minute: '%d-%m-%Y<br/>%H:%M',
                            hour: '%d-%m-%Y<br/>%H:%M',
                            day: '%Y<br/>%d-%m',
                            week: '%Y<br/>%d-%m',
                            month: '%m-%Y',
                            year: '%Y'
                        },
                        gridLineColor: '#C0C0C0',
                        gridLineWidth: 1,
                        title: {
                            text: 'Fechas'
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Costo/Variacion'
                        },
                        stackLabels: {
                            enabled: false,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            }
                        }
                    },
                    plotOptions: {
                        spline: {
                            marker: {
                                enabled: true
                            }
                        },
                        series: {
                            lastPrice: {
                                enabled: true,
                                color: 'red'
                            },
                            marker: {
                                enabled: true,
                                radius: 3
                            },
                            point: {
                                events: {
                                    click: (e) => {
                                        this.x = e.x;
                                        this.y = e.y;
                                        this.detalle(e)
                                    }
                                }
                            }
                        }
                    },
                    series: []
                }
            }
        },
        methods: {
            ...mapActions('progreso', ['progresoShow', 'progresoHide']),
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/costo/historia', this.d)
                    .then(r => {
                        this.chartOptions.subtitle.text = this.d.producto.B1_COD + ' | ' + this.d.producto.B1_DESC;

                        if (this.d.tipo === 'costo') {
                            this.chartOptions.series = r.data.costo;
                            this.chartOptions.yAxis[0].title.text = 'Costo';
                            this.chartOptions.tooltip.pointFormat = '{series.name} | {point.compl}: Costo: <b>{point.y:,.1f}</b>';

                        } else {
                            this.chartOptions.series = r.data.variacion;
                            this.chartOptions.yAxis[0].title.text = 'Variación';
                            this.chartOptions.tooltip.pointFormat = '{series.name} | {point.compl}: Variacion: <b>{point.y:,.1f}%</b>';
                        }
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            },
            arreglaCostoSdi() {//ARREGLA COSTO SDI
                this.$http.post('test/costo', this.d)
                    .then(r => {
                        alert(r.data)
                    })
                    .catch(err => {
                        alert(err)
                    })
            },
            variacionCalc() {
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'indicadores/costo/variacion',
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob",
                    data: this.d
                })
                    .then((response) => {
                        saveAs(response.data, 'costoErrores.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            },
            detalle(e) {
                this.progresoShow();
                this.$http.post('indicadores/costo/historia/detalle', {
                    d: this.d,
                    fecha: e.point.fecha,
                    dep: e.point.dep
                })
                    .then(r => {
                        this.items = r.data;
                        this.progresoHide();
                        this.lateral = false;
                        this.seriesShow = true;
                    }, r => {
                        alert(r);
                        this.progresoHide();
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/costo-historia.vue